export { cardVariables as cardExpandableBoxVariables } from './cardVariables';
